import React from 'react'
import { Logo } from '../logo/Logo'
import { Link } from 'react-router-dom'
import './main.css'


const Main = ({ setCpu }) => {

  return (
    <div className="main__container buttons__container">
      <div className='main__content'>
        <div className='header__container'>
          <p>CONNECT-4</p>
          <Logo />
        </div>
        <Link to={'/game'} className="main__button button-pink" onClick={() => setCpu(2)}>PLAYER FIRST</Link>
        <Link to={'/game'} className="main__button button-yellow" onClick={() => setCpu(1)}>COMPUTER FIRST</Link>
        <Link to={'/game'} className="main__button button-pink" onClick={() => setCpu(0)}>PLAYER VS PLAYER</Link>
        {/* <Link to={'/rules'} className="main__button button-withe">Game Rules</Link> */}
      </div>

    </div>
  )
}

export { Main }